// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8waNw","label":"styles_label__90Vj4","fieldRequired":"styles_fieldRequired__Y87Wt"};